import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getCompetitorChart2Data } from 'gqlQueries/priceLadder';
import { priceLadderAttributeLevelChart2Parser } from 'parser/priceLadderParser';
const errorMessage: string = 'Something went wrong!';

function useFetchCompetitorPriceLadderChart2() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    const [
        fetchCompetitorPriceLadderChart2,
        { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError },
    ] = useLazyQuery(getCompetitorChart2Data, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getCompetitorsPricePointChangeData } = payload;
            if (getCompetitorsPricePointChangeData && 'values' in getCompetitorsPricePointChangeData) {
                const parsedChartData = priceLadderAttributeLevelChart2Parser(
                    getCompetitorsPricePointChangeData?.values,
                    getCompetitorsPricePointChangeData?.baseLineValue,
                );
                setData({ chartData: parsedChartData });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        setError: (message: any) => {
            onFetchError(message);
        },
        fetchCompetitorPriceLadderChart2: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }
            setLoading(true);
            setError(null);
            fetchCompetitorPriceLadderChart2(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchCompetitorPriceLadderChart2 };
